import React from 'react';
import SelectDropdown from "../../SelectDropdown";
import {useSurveyContext} from "../../../context/SurveyContext";

function DropdownQuestion(props) {
    const {survey: {answers}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id] || "";

    const isShown = props.question.part === props.activePart;
    const elementId = `dropdown-${props.question.id}`;
    return (
        <div className={isShown ? "w-full sm:w-1/2 xl:w-1/3" : "hidden"}>
            <SelectDropdown
                selectId={elementId}
                labelClasses="block input-label mb-1"
                label={props.question.questionText}
                options={props.question.options}
                handleChange={e => setAnswer(props.question.id, e.target.value)}
                value={answer}
            />
        </div>
    );
}

export default DropdownQuestion;